
import React from 'react';
import { DashboardTable } from "../../../client/components/dashboard-table";

const render_funding_source_table = (
  component, dwolla, ids, checkbox_param) => {

  const data = [];

  const headerStyle = {
    fontSize: "1.2rem",
    fontWeight: "800",
  }
  data.push([
    (<span style={headerStyle}>Bank</span>),
    (<span style={headerStyle}>Account Name</span>),
    (<span style={headerStyle}>Account Type</span>),
  ]);
  if (checkbox_param) {
    data[0].unshift("");
  }

  ids.forEach((id, index) => {
    const funding_source = dwolla.funding_source[id];

    data.push([
      (<span>{funding_source.bank_name}</span>),
      (<span>{funding_source.name}</span>),
      (<span>{funding_source.account_type}</span>),
    ]);
    if (checkbox_param) {
      data[data.length-1].unshift(
        checkbox_param.renderCheckbox(index, component));
    }
  });

  const td_style = {
    paddingLeft: "0.5rem",
  }
  const table_style = {
    overflow: "auto",
    width: "100%",
    tableLayout: "auto",
  }

  return (
    <DashboardTable
      tableStyle={table_style}
      hLines={true}
      align={["center", "center", "center"]}
      data={data}
      title={"funding_source_table"}
      td_style={td_style}
    />);
};

export { render_funding_source_table };
